/* Hamada Bio — COD Form v2.3 (Meta + TikTok) — needs hb-cod-data.js; per-offer variant_id + compare_at */
(function () {
'use strict';
var SRC = (document.currentScript || {}).src || '';
function start() {
var U = window.HBU, fmt = U.fmt, el = U.el, esc = U.esc, track = U.track, ttclid = U.ttclid, HB_W = window.HB_W;
function init(root) {
 var cfg = JSON.parse(root.querySelector('[data-hb-config]').textContent);
 var T = cfg.text, P = cfg.product, cur = T.currency;
 var state = { offer: 0, delivery: 'home', wilaya: null, sent: false, startedAt: Date.now(), atc: false, ic: false };
 try { if (window.ttq) window.ttq.track('ViewContent', { value: P.price, currency: 'DZD', content_type: 'product', contents: [{ content_id: String(P.variant_id), content_name: P.title, quantity: 1 }] }); } catch (e) {}
 var found = (cfg.offers && cfg.offers.length) ? cfg.offers : [].map.call(root.querySelectorAll('[data-hb-offer]'), function (s) { try { return JSON.parse(s.textContent); } catch (e) { return null; } }).filter(function (o) { return o && o.qty > 0 && o.price > 0; });
 var offers = found.length ? found : [{ label: T.single_label, qty: 1, price: P.price, free: false, badge: '', gift: '' }];
 offers.forEach(function (o) {
  var ca = +o.compare_at || 0;
  o.compare = ca > o.price ? ca : (P.compare && P.compare > P.price ? P.compare * o.qty : P.price * o.qty);
  o.vid = +o.variant_id > 0 ? +o.variant_id : P.variant_id;
  if (o.free) { o.home_mode = 'free'; o.desk_mode = 'free'; }
  o.home_mode = o.home_mode || 'normal'; o.desk_mode = o.desk_mode || 'normal';
  o.home_value = +o.home_value || 0; o.desk_value = +o.desk_value || 0;
 });
 function feeFor(o, w, t) {
  if (!w) return null;
  var base = t === 'home' ? w.home : w.desk, m = o[t + '_mode'], v = o[t + '_value'];
  if (m === 'free') return 0;
  if (m === 'discount') return Math.max(0, base - v);
  if (m === 'fixed') return Math.max(0, v);
  return base;
 }
 function shipChips(o) {
  var h = o.home_mode, d = o.desk_mode, out = [];
  if (h === 'free' && d === 'free') return [T.free_shipping];
  if (d === 'free') out.push(T.free_desk || 'توصيل مجاني للمكتب');
  if (h === 'free') out.push(T.free_home || 'توصيل مجاني للمنزل');
  if (h === 'discount' && o.home_value) out.push((T.home_discount || 'تخفيض {x} على توصيل المنزل').replace('{x}', fmt(o.home_value, cur)));
  if (d === 'discount' && o.desk_value) out.push((T.desk_discount || 'تخفيض {x} على توصيل المكتب').replace('{x}', fmt(o.desk_value, cur)));
  if (h === 'fixed') out.push((T.home_fixed || 'توصيل المنزل بـ {x}').replace('{x}', fmt(o.home_value, cur)));
  if (d === 'fixed') out.push((T.desk_fixed || 'توصيل المكتب بـ {x}').replace('{x}', fmt(o.desk_value, cur)));
  return out;
 }
 var def = offers.findIndex(function (o) { return o.default; });
 state.offer = def >= 0 ? def : 0;
 var form = root.querySelector('.hbf-form'), offersBox = root.querySelector('.hbf-offers');
 var wSel = root.querySelector('[name=wilaya]'), cSel = root.querySelector('[name=commune]');
 var sum = root.querySelector('.hbf-summary'), btn = root.querySelector('.hbf-submit'), err = root.querySelector('.hbf-error');
 var lang = cfg.lang === 'fr' ? 'fr' : 'ar';
 function renderOffers() {
  offersBox.innerHTML = '';
  if (offers.length < 2) { offersBox.style.display = 'none'; return; }
  offers.forEach(function (o, i) {
   var save = o.compare - o.price;
   var card = el('label', { class: 'hbf-offer' + (i === state.offer ? ' is-on' : '') });
   card.innerHTML =
    '<input type="radio" name="offer" value="' + i + '"' + (i === state.offer ? ' checked' : '') + '>' +
    (o.badge ? '<span class="hbf-badge">' + esc(o.badge) + '</span>' : '') +
    '<span class="hbf-radio"></span><span class="hbf-offer-main"><b>' + esc(o.label) + '</b>' +
    shipChips(o).map(function (c) { return '<span class="hbf-chip hbf-chip-ship">🚚 ' + esc(c) + '</span>'; }).join('') +
    (o.gift ? '<span class="hbf-chip hbf-chip-gift">🎁 ' + esc(o.gift) + '</span>' : '') +
    '</span><span class="hbf-offer-price"><b>' + fmt(o.price, cur) + '</b>' +
    (save > 0 ? '<s>' + fmt(o.compare, cur) + '</s><em>' + esc(T.save) + ' ' + fmt(save, cur) + '</em>' : '') + '</span>';
   card.querySelector('input').addEventListener('change', function () {
    state.offer = i; renderOffers(); renderDelivery(); renderSummary();
    if (!state.atc) { state.atc = true; track('AddToCart', payload()); }
   });
   offersBox.appendChild(card);
  });
 }
 var over = {};
 String(cfg.fees_override || '').split(/[\n,]+/).forEach(function (l) {
  var p = l.trim().split(':').map(function (x) { return parseInt(x, 10); });
  if (p.length === 3 && p.every(function (x) { return !isNaN(x); })) over[p[0]] = [p[1], p[2]];
 });
 var W = HB_W.map(function (r) {
  var o = over[r[0]];
  return { code: r[0], ship: r[1], ar: r[2], fr: r[3], home: o ? o[0] : r[4], desk: o ? o[1] : r[5] };
 });
 W.forEach(function (w, i) {
  wSel.appendChild(el('option', { value: i }, String(w.code).padStart(2, '0') + ' - ' + esc(lang === 'fr' ? w.fr : w.ar)));
 });
 var communesP = null;
 function loadCommunes() {
  if (!communesP) communesP = fetch(cfg.communes_url).then(function (r) { return r.json(); }).then(function (list) {
   var by = {};
   list.forEach(function (x) { var c = parseInt(x.wilaya_code, 10); (by[c] = by[c] || []).push([x.commune_name, x.commune_name_ascii]); });
   Object.keys(by).forEach(function (k) { by[k].sort(function (a, b) { return a[0].localeCompare(b[0], 'ar'); }); });
   return by;
  }).catch(function () { return null; });
  return communesP;
 }
 setTimeout(loadCommunes, 1200);
 function communeFallback() {
  if (cSel.tagName === 'INPUT') return;
  var inp = el('input', { name: 'commune', type: 'text', placeholder: T.commune_ph, id: cSel.id || '' });
  cSel.parentNode.replaceChild(inp, cSel); cSel = inp;
 }
 wSel.addEventListener('change', function () {
  state.wilaya = W[wSel.value] || null;
  renderDelivery(); renderSummary();
  if (cSel.tagName === 'INPUT') return;
  cSel.innerHTML = '<option value="">' + esc(T.commune_ph) + '</option>';
  cSel.disabled = true;
  if (!state.wilaya) return;
  var w = state.wilaya;
  loadCommunes().then(function (by) {
   if (!by || !by[w.ship]) { communeFallback(); return; }
   if (state.wilaya !== w) return;
   by[w.ship].forEach(function (c) { cSel.appendChild(el('option', { value: c[1] + '|' + c[0] }, esc(lang === 'fr' ? c[1] : c[0]))); });
   cSel.disabled = false;
  });
 });
 var dBox = root.querySelector('.hbf-delivery');
 function renderDelivery() {
  var w = state.wilaya, o = offers[state.offer];
  dBox.querySelectorAll('[data-type]').forEach(function (b) {
   var t = b.getAttribute('data-type');
   var fee = feeFor(o, w, t), base = w ? (t === 'home' ? w.home : w.desk) : null;
   b.classList.toggle('is-on', state.delivery === t);
   var html;
   if (!w) html = o[t + '_mode'] === 'free' ? '<b class="hbf-free">' + esc(T.free_shipping) + '</b>' : esc(T.pick_wilaya_first);
   else if (fee === 0) html = '<s>' + fmt(base, cur) + '</s> <b class="hbf-free">' + esc(T.free_shipping) + '</b>';
   else if (fee < base) html = '<s>' + fmt(base, cur) + '</s> ' + fmt(fee, cur);
   else html = fmt(fee, cur);
   b.querySelector('small').innerHTML = html;
  });
 }
 dBox.querySelectorAll('[data-type]').forEach(function (b) {
  b.addEventListener('click', function () { state.delivery = b.getAttribute('data-type'); renderDelivery(); renderSummary(); });
 });
 function shipFee() { return feeFor(offers[state.offer], state.wilaya, state.delivery) || 0; }
 function payload() {
  var o = offers[state.offer];
  return { value: o.price + shipFee(), currency: 'DZD', content_ids: [String(o.vid)], content_type: 'product', num_items: o.qty, content_name: P.title };
 }
 function renderSummary() {
  var o = offers[state.offer], f = shipFee();
  sum.innerHTML =
   '<div><span>' + esc(T.sum_product) + ' (×' + o.qty + ')</span><span>' + fmt(o.price, cur) + '</span></div>' +
   '<div><span>' + esc(T.sum_shipping) + '</span><span>' + (state.wilaya ? (f === 0 ? '<b class="hbf-free">' + esc(T.free_shipping) + '</b>' : fmt(f, cur)) : (o[state.delivery + '_mode'] === 'free' ? '<b class="hbf-free">' + esc(T.free_shipping) + '</b>' : '—')) + '</span></div>' +
   '<div class="hbf-total"><span>' + esc(T.sum_total) + '</span><span>' + fmt(o.price + f, cur) + '</span></div>';
  btn.querySelector('.hbf-submit-price').textContent = fmt(o.price + f, cur);
 }
 form.addEventListener('focusin', function () { if (!state.ic) { state.ic = true; track('InitiateCheckout', payload()); } });
 var phone = root.querySelector('[name=phone]');
 phone.addEventListener('input', function () { phone.value = phone.value.replace(/[^\d]/g, '').slice(0, 10); });
 function invalid(input, msg) {
  input.closest('.hbf-field').classList.add('is-err');
  err.textContent = msg; err.hidden = false; input.focus(); return false;
 }
 function validate() {
  root.querySelectorAll('.is-err').forEach(function (f) { f.classList.remove('is-err'); });
  err.hidden = true;
  var name = root.querySelector('[name=name]');
  if (name.value.trim().length < 3) return invalid(name, T.err_name);
  if (!/^0[567]\d{8}$/.test(phone.value)) return invalid(phone, T.err_phone);
  if (!state.wilaya) return invalid(wSel, T.err_wilaya);
  if (!cSel.value) return invalid(cSel, T.err_commune);
  return true;
 }
 function collect() {
  var o = offers[state.offer], w = state.wilaya;
  var comm = cSel.value ? cSel.value.split('|') : ['', ''];
  if (comm.length < 2) comm = [cSel.value.trim(), cSel.value.trim()];
  return {
   shop: cfg.shop, variant_id: o.vid, product_title: P.title,
   offer: { label: o.label, qty: o.qty, price: o.price, free: shipFee() === 0, gift: o.gift || '' },
   name: root.querySelector('[name=name]').value.trim(), phone: phone.value,
   wilaya_code: w ? w.code : '', ship_code: w ? w.ship : '', wilaya: w ? w.fr : '', wilaya_ar: w ? w.ar : '',
   commune: comm[0], commune_ar: comm[1], address: (root.querySelector('[name=address]') || {}).value || '',
   delivery: state.delivery, shipping: shipFee(), total: o.price + shipFee(),
   elapsed: Date.now() - state.startedAt, page: location.href,
   fbp: (document.cookie.match(/_fbp=([^;]+)/) || [])[1] || '', fbc: (document.cookie.match(/_fbc=([^;]+)/) || [])[1] || '',
   ttclid: ttclid(), ttp: (document.cookie.match(/(?:^|; )_ttp=([^;]+)/) || [])[1] || ''
  };
 }
 var base = String(cfg.endpoint || '').replace(/\/+$/, '');
 var partial = { last: '', count: 0, timer: null };
 function sendPartial(final) {
  if (!base || state.sent || !/^0[567]\d{8}$/.test(phone.value)) return;
  var b = collect(); delete b.elapsed;
  var json = JSON.stringify(b);
  if (json === partial.last) return;
  if (!final && partial.count >= 4) return;
  partial.last = json; partial.count++;
  try {
   if (final && navigator.sendBeacon) { navigator.sendBeacon(base + '/partial', new Blob([json], { type: 'text/plain' })); return; }
   fetch(base + '/partial', { method: 'POST', body: json, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
  } catch (e) {}
 }
 function schedulePartial() { clearTimeout(partial.timer); partial.timer = setTimeout(function () { sendPartial(false); }, 1500); }
 phone.addEventListener('input', function () { if (/^0[567]\d{8}$/.test(phone.value)) schedulePartial(); });
 form.addEventListener('change', function () { if (/^0[567]\d{8}$/.test(phone.value)) schedulePartial(); });
 window.addEventListener('pagehide', function () { sendPartial(true); });
 document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') sendPartial(true); });
 form.addEventListener('submit', function (e) {
  e.preventDefault();
  if (state.sent || !validate()) return;
  if (form.website && form.website.value) return;
  var body = collect();
  clearTimeout(partial.timer);
  state.sent = true; btn.classList.add('is-loading'); btn.disabled = true;
  var req = cfg.endpoint
   ? fetch(base, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); })
   : new Promise(function (res) { setTimeout(function () { res({ ok: true, demo: true, order_name: '#DEMO' + Math.floor(1000 + Math.random() * 8999), event_id: 'demo_' + Date.now() }); }, 900); });
  req.then(function (r) {
   if (!r || !r.ok) throw new Error((r && r.error) || 'error');
   if (cfg.track_purchase !== false && cfg.endpoint) {
    try { if (window.ttq) window.ttq.identify({ phone_number: '+213' + body.phone.slice(1), external_id: body.phone }); } catch (e) {}
    track('Purchase', payload(), r.event_id);
   }
   thanks(r, body);
  }).catch(function (ex) {
   state.sent = false; btn.classList.remove('is-loading'); btn.disabled = false;
   err.textContent = ex.message === 'duplicate' ? T.err_duplicate : T.err_server; err.hidden = false;
  });
 });
 function thanks(r, b) {
  var wa = '';
  if (cfg.whatsapp) {
   var msg = (T.wa_message || '').replace('{order}', r.order_name).replace('{name}', b.name).replace('{product}', P.title);
   wa = '<a class="hbf-wa" target="_blank" rel="noopener" href="https://wa.me/' + cfg.whatsapp.replace(/\D/g, '') + '?text=' + encodeURIComponent(msg) + '">' + U.WA_SVG + esc(T.wa_button) + '</a>';
  }
  var o = offers[state.offer];
  root.querySelector('.hbf-card').innerHTML =
   '<div class="hbf-thanks">' +
   (r.demo ? '<p class="hbf-error">⚠️ وضع تجريبي: الطلب ما تسجلش في Shopify. زيد رابط السيرفر في إعدادات الفورم.</p>' : '') +
   '<div class="hbf-check"><svg viewBox="0 0 52 52"><circle cx="26" cy="26" r="24"/><path d="M15 27l7 7 15-16"/></svg></div>' +
   '<h3>' + esc(T.thanks_title).replace('{name}', esc(b.name.split(' ')[0])) + '</h3><p>' + esc(T.thanks_text) + '</p>' +
   '<div class="hbf-receipt"><div><span>' + esc(T.order_no) + '</span><b>' + esc(r.order_name) + '</b></div>' +
   '<div><span>' + esc(o.label || P.title) + '</span><b>×' + o.qty + '</b></div>' +
   '<div><span>' + esc(lang === 'fr' ? b.wilaya : b.wilaya_ar) + ' — ' + esc(lang === 'fr' ? b.commune : b.commune_ar) + '</span><b>' + esc(b.delivery === 'home' ? T.home : T.desk) + '</b></div>' +
   '<div class="hbf-total"><span>' + esc(T.sum_total) + '</span><b>' + fmt(b.total, cur) + '</b></div></div>' + wa + '</div>';
  var fab = document.querySelector('.hbf-fab'); if (fab) fab.remove();
  root.scrollIntoView({ behavior: 'smooth', block: 'start' });
 }
 var fab = root.querySelector('.hbf-fab');
 if (fab) {
  var fc = getComputedStyle(root).getPropertyValue('--hb-fab');
  if (fc) fab.style.setProperty('--hb-fab', fc.trim());
  document.body.appendChild(fab);
  fab.addEventListener('click', function () {
   root.scrollIntoView({ behavior: 'smooth', block: 'start' });
   setTimeout(function () { var n = root.querySelector('[name=name]'); if (n) n.focus({ preventScroll: true }); }, 600);
  });
  if ('IntersectionObserver' in window) {
   new IntersectionObserver(function (ent) { fab.classList.toggle('is-hidden', ent[0].isIntersecting); }, { threshold: 0.15 }).observe(root.querySelector('.hbf-card'));
  }
 }
 renderOffers(); renderDelivery(); renderSummary();
}
function boot() { document.querySelectorAll('[data-hb-cod]').forEach(function (r) { if (!r._hb) { r._hb = 1; init(r); } }); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
document.addEventListener('shopify:block:select', boot);
}
if (window.HBU && window.HB_W) start();
else {
 var s = document.createElement('script');
 s.src = SRC.replace('hb-cod-form.js', 'hb-cod-data.js');
 s.onload = start;
 document.head.appendChild(s);
}
})();